import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";


export const getCampaniasPostVenta = async (filters) => {
  try {
    const response = await mainAxios.post(
      `/v1/campaniasPostventa/getByFiltros`,
      filters,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAllCampaniasPostVenta = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/campaniasPostventa/list`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
